export default {
  DEFAULT_CLASS_NAME: `rmlm-container`,
  DEFAULT_SUBMENU_CLASS_NAME: `rmlm-submenu`,
  DEFAULT_LIST_CLASS_NAME: `rmlm-item-container`,
  DEFAULT_LIST_WRAPPER_CLASS_NAME: `rmlm-item-wrapper`,
  DEFAULT_LIST_DATA_CLASS_NAME: `rmlm-list-data`,
  DEFAULT_LIST_ICON_CLASS_NAME: `rmlm-list-icon`,
  DEFAULT_LIST_ICON_CONTAINER_CLASS_NAME: `rmlm-icon-container`,
  DEFAULT_LIST_ICON_FA_CLASS_NAME: `rmlm-icon-fa`,
  DEFAULT_LIST_LABEL_CLASS_NAME: `rmlm-list-label`,
  SELECTED_LIST_CLASS_NAME: `selected-rmlm-item`,
  ACTIVE_ITEM_CLASS_NAME: `active-rmlm-item`,
  DISABLED_ITEM_CLASS_NAME: `disabled-rmlm-item`,
  DEFAULT_DIRECTION_ICON_CLASS_NAME: `rmlm-icon-arrow-container`,
  DEFAULT_DIVIDER_CLASS_NAME: `rmlm-dividers`,
  DEFAULT_ERROR_CLASS_NAME: `rmlm-error-container`,

  DEFAULT_SELECTED_FONT_COLOR: `#1976d2`,
  DEFAULT_LIST_BACKGROUND_COLOR: `transparent`,
  DEFAULT_LIST_FONT_COLOR: `rgba(0,0,0,.87)`,
  DEFAULT_HREF_TARGET_TYPE: '_self',

  ERROR_MESSAGE: `Invalid data for  Multilevel List Component.`,
};
